import { Box, Center } from '@chakra-ui/react';
import useCurrentTheme from 'features/website-layout/hooks/useCurrentTheme';
import { getColor } from 'features/website-layout/utilities/getColor';

import CircleLoader from './CircleLoader';

type Props = {
  isThemed?: boolean;
};

function SplashScreen({ isThemed }: Props) {
  const currentTheme = useCurrentTheme();

  return (
    <Box w="full" h="100vh">
      <Center w="full" h="full">
        <CircleLoader color={isThemed ? getColor(currentTheme) : 'blue.500'} />
      </Center>
    </Box>
  );
}

export default SplashScreen;
